import { FullAudit, IsActiveFlag } from '@/types';

export interface ContactEmailModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    contactId: number;
    email: string;
    isMain: boolean;
}
